/// <amd-module name="CodeCoverage/ViewCommon/Helpers" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

import { getTFSProject } from "Tfs/Platform/Page";

import { TelemetryEvents } from "CodeCoverage/ViewCommon/Constants";

export function publish(pageContext: IVssPageContext, feature: string, buildId?: number, properties?: { [key: string]: any }): void {
    const service = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    const project = getTFSProject(pageContext);
    const projectId = project && project.id;

    service.publishEvent(TelemetryEvents.Area, feature, {
        ...properties,
        projectId,
        buildId
    });
}

export function getCoverageChangeIconName(coverageChangePercentage: number): string {
    let coverageChangeIcon: string;

    if (coverageChangePercentage > 0) {
        coverageChangeIcon = "StockUp";
    } else if (coverageChangePercentage < 0) {
        coverageChangeIcon = "StockDown";
    } else {
        coverageChangeIcon = "DashKey";
    }

    return coverageChangeIcon;
}
